import * as React from 'react';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import { isSellerFollowed } from '@/redux/modules/followSeller';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

type Props = {
    children: React.ReactNode;
    className?: string;
    longText?: boolean;
    onClick: Function;
    primaryWithSecondarySuccess: boolean;
    secondary: boolean;
    sellerId: number;
    small: boolean;
};
//TODO op-118 is this ok? There was no primary secondarySuccess option, so I am not sure what this was supposed to do.
const FollowSellerButton = (props: Props) => {
    const {
        children,
        className,
        longText,
        onClick,
        primaryWithSecondarySuccess = false,
        secondary = false,
        sellerId,
        small = false,
    } = props;

    const followed = useSelector((state) => isSellerFollowed(state, sellerId));

    if (children) {
        return (
            <Button
                className={className}
                e2e="followSellerButton"
                onClick={onClick}
                primary={!followed}
                secondary={followed}
                small={small}
            >
                {children}
            </Button>
        );
    }

    const follow = !longText ? 'follow' : 'follow_auctioneer';
    const following = !longText ? 'following' : 'following_auctioneer';

    if (secondary) {
        return (
            <Button
                className={className}
                e2e="followSellerButton"
                green={followed}
                onClick={onClick}
                secondary={followed}
                small={small}
            >
                {!followed ? (
                    <>
                        <StyledFontAwesomeIcon icon={faEnvelope} />
                        <FormattedMessage id={follow} />
                    </>
                ) : (
                    <>
                        <StyledFontAwesomeIcon icon={faCheckCircle} />
                        <FormattedMessage id={following} />
                    </>
                )}
            </Button>
        );
    }

    if (primaryWithSecondarySuccess) {
        return (
            <Button
                className={className}
                e2e="followSellerButton"
                green={followed}
                onClick={onClick}
                primary={!followed}
                secondary={followed}
                small={small}
            >
                {!followed ? (
                    <>
                        <StyledFontAwesomeIcon icon={faEnvelope} />
                        <FormattedMessage id={follow} />
                    </>
                ) : (
                    <>
                        <StyledFontAwesomeIcon icon={faCheckCircle} />
                        <FormattedMessage id={following} />
                    </>
                )}
            </Button>
        );
    }

    return (
        <Button
            className={className}
            e2e="followSellerButton"
            onClick={onClick}
            primary={!followed}
            secondary={followed}
            small={small}
        >
            <StyledFontAwesomeIcon icon={faEnvelope} />
            {!followed ? <FormattedMessage id={follow} /> : <FormattedMessage id={following} />}
        </Button>
    );
};

export default React.memo<Props>(FollowSellerButton, isEqual);

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
    margin-right: 9px;
    height: 11px;
    width: 14px;
`;
